module.exports = __webpack_public_path__ + "static/media/CT_2019_30441_8746_pdf.3c1ead4a.pdf";